/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const { 
	addIsChecking, 
	removeIsChecking, 
	clearIsChecking,

	addHasChecked, 
	removeHasChecked, 
	clearHasChecked,

	addHasUserData, 
	removeHasUserData, 
	clearHasUserData,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
 } = createActions(
	{
		ADD_IS_CHECKING: (survey) => ({ survey }),
		REMOVE_IS_CHECKING: (survey) => ({ survey }),
		CLEAR_IS_CHECKING: () => ({}),

		ADD_HAS_CHECKED: (survey) => ({ survey }),
		REMOVE_HAS_CHECKED: (survey) => ({ survey }),
		CLEAR_HAS_CHECKED: () => ({}),

		ADD_HAS_USER_DATA: (survey) => ({ survey }),
		REMOVE_HAS_USER_DATA: (survey) => ({ survey }),
		CLEAR_HAS_USER_DATA: () => ({}),

		ADD_ERROR_MESSAGES: (survey, message) => ({ 
			survey,
			message, 
		}),
		REMOVE_ERROR_MESSAGES: (survey) => ({ survey }),
		CLEAR_ERROR_MESSAGES: () => ({}),

		CLEAR: () => ({}),
	},
	{ prefix: ROOT_SLICE }
);

export { 
	addIsChecking, 
	removeIsChecking, 
	clearIsChecking,

	addHasChecked, 
	removeHasChecked, 
	clearHasChecked,

	addHasUserData, 
	removeHasUserData, 
	clearHasUserData,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
};
